import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface CreateEmbeddingsState {
  message: any;
  isLoading: boolean;
  error: string | null;
}

const initialState: CreateEmbeddingsState = {
  message: null,
  isLoading: false,
  error: null,
};

const createEmbeddingsSlice = createSlice({
  name: "createEmbeddings",
  initialState,
  reducers: {
    setCreateEmbeddings: (state, action: PayloadAction<any>) => {
      state.message = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
      state.error = null;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    resetCreateEmbeddings: () => initialState,
  },
});

export const {
  setCreateEmbeddings,
  setLoading,
  setError,
  resetCreateEmbeddings,
} = createEmbeddingsSlice.actions;

export default createEmbeddingsSlice.reducer;
